var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg_home"},[_c('app-home-banner',{attrs:{"filteredAnnouncement":_vm.filteredAnnouncement}}),_c('app-game-tab-holder'),_c('app-referral-home-banner',{staticStyle:{"background":"#1C1632"}}),_c('app-download-client')],1)}
var staticRenderFns = []

export { render, staticRenderFns }